import { maskingPolicyActionTypes } from '@Actions/settings/maskingPolicyActions';

const MaskingPolicyReducer = (state = { }, action) => {
  switch (action.type) {
  case maskingPolicyActionTypes.CREATE_MASKING_POLICY.LOADING: {
    const { createMaskingPolicyLoading } = action;
    return {
      ...state,
      createMaskingPolicyLoading,
    };
  }
  case maskingPolicyActionTypes.GET_MASKING_POLICIES.LOADING: {
    const { getMaskingPoliciesLoading } = action;
    return {
      ...state,
      getMaskingPoliciesLoading,
    };
  }
  case maskingPolicyActionTypes.GET_MASKING_POLICIES.SUCCESS: {
    const { maskingPolicies } = action;
    return {
      ...state,
      maskingPolicies,
    };
  }
  case maskingPolicyActionTypes.GET_MASKING_POLICY_BY_ID.LOADING: {
    const { getMaskingPolicyById } = action;
    return {
      ...state,
      getMaskingPolicyById,
    };
  }
  case maskingPolicyActionTypes.GET_MASKING_POLICY_BY_ID.SUCCESS: {
    const { selectedMaskingPolicy } = action;
    return {
      ...state,
      selectedMaskingPolicy,
    };
  }
  case maskingPolicyActionTypes.UPDATE_MASKING_POLICY.LOADING: {
    const { updateMaskingPolicyLoading } = action;
    return {
      ...state,
      updateMaskingPolicyLoading,
    };
  }
  case maskingPolicyActionTypes.DELETE_MASKING_POLICY.LOADING: {
    const { deleteMaskingPolicyLoading } = action;
    return {
      ...state,
      deleteMaskingPolicyLoading,
    };
  }
  case maskingPolicyActionTypes.MASKING_POLICY_EDIT_PAGE.LOADING: {
    const { getMaskingPolicyEditPage } = action;
    return {
      ...state,
      getMaskingPolicyEditPage,
    };
  }
  case maskingPolicyActionTypes.MASKING_POLICY_EDIT_PAGE.SUCCESS: {
    const { maskingPolicyEditPage } = action;
    return {
      ...state,
      maskingPolicyEditPage,
    };
  }

  default: {
    return state;
  }
  }
};

export default MaskingPolicyReducer;
